var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconnav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "octicon:filter-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.96875 7.875H40.0312C40.5534 7.875 41.0542 8.08242 41.4234 8.45163C41.7926 8.82085 42 9.32161 42 9.84375C42 10.3659 41.7926 10.8667 41.4234 11.2359C41.0542 11.6051 40.5534 11.8125 40.0312 11.8125H1.96875C1.44661 11.8125 0.945846 11.6051 0.576634 11.2359C0.207421 10.8667 0 10.3659 0 9.84375C0 9.32161 0.207421 8.82085 0.576634 8.45163C0.945846 8.08242 1.44661 7.875 1.96875 7.875ZM7.875 20.3438C7.875 19.8216 8.08242 19.3208 8.45163 18.9516C8.82085 18.5824 9.3216 18.375 9.84375 18.375H32.1562C32.6784 18.375 33.1792 18.5824 33.5484 18.9516C33.9176 19.3208 34.125 19.8216 34.125 20.3438C34.125 20.8659 33.9176 21.3667 33.5484 21.7359C33.1792 22.1051 32.6784 22.3125 32.1562 22.3125H9.84375C9.3216 22.3125 8.82085 22.1051 8.45163 21.7359C8.08242 21.3667 7.875 20.8659 7.875 20.3438ZM15.75 30.8438C15.75 30.3216 15.9574 29.8208 16.3266 29.4516C16.6958 29.0824 17.1966 28.875 17.7188 28.875H24.2812C24.8034 28.875 25.3042 29.0824 25.6734 29.4516C26.0426 29.8208 26.25 30.3216 26.25 30.8438C26.25 31.3659 26.0426 31.8667 25.6734 32.2359C25.3042 32.6051 24.8034 32.8125 24.2812 32.8125H17.7188C17.1966 32.8125 16.6958 32.6051 16.3266 32.2359C15.9574 31.8667 15.75 31.3659 15.75 30.8438Z",
    fill: "#3E4DAC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconnav);
export default __webpack_public_path__ + "static/media/Iconnav.1e0cdb9591baebfe47c8da972a8c3564.svg";
export { ForwardRef as ReactComponent };